/** Reuse the product's persisted default design; never create a second template for an area. */
export const getComposerDefaultTemplate = <T extends { templateID: number }>(templates: T[], defaultTemplateID: number | null | undefined): T | undefined => {
    const id = Number(defaultTemplateID || 0);
    return templates.find((template) => id > 0 && template.templateID === id) ?? templates.find((template) => template.templateID > 0) ?? templates[0];
};
